<template>
    <div class="card">
        <div class="card-body" v-if="chartOptions">
            <p class="chart-title">Meses por Formato</p>
            <apexcharts type="heatmap" height="550" :options="chartOptions" :series="chartSeries" />
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
    components: { apexcharts: VueApexCharts },
    props: {
        tabela: {
            type: Object,
            required: true
        }
    },
    computed: {
        meses() {
            const mesesOrdem = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
            const set = new Set();
            Object.values(this.tabela).forEach(porFormato => {
                Object.values(porFormato).forEach(mesInfo => set.add(mesInfo.mes_name));
            });
            return mesesOrdem.filter(m => set.has(m));
        },
        formatos() {
            const set = new Set();
            Object.values(this.tabela).forEach(porFormato => {
                Object.values(porFormato).forEach(mesInfo => set.add(mesInfo.formato_name));
            });
            return Array.from(set);
        },
        chartSeries() {
            return this.formatos.map(formato => {
                return {
                    name: formato,
                    data: this.meses.map(mes => {
                        let qtd = null;
                        for (const formatoId in this.tabela) {
                            const mesesObj = this.tabela[formatoId];
                            for (const mesId in mesesObj) {
                                const info = mesesObj[mesId];
                                if (info.formato_name === formato && info.mes_name === mes) {
                                    qtd = info.quantidade;
                                }
                            }
                        }
                        return qtd || 0;
                    })
                }
            });
        },
        chartOptions() {
            return {
                chart: {
                    type: "heatmap",
                    toolbar: { show: false }
                },
                dataLabels: { enabled: true },
                xaxis: {
                    categories: this.meses
                },
                yaxis: {
                    title: { text: 'Formatos' }
                },
                colors: ["#008FFB"]
            }
        }
    }
}
</script>
<style>
.apexcharts-canvas {
    margin: 0 auto !important;
}
</style>
